// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__wqkSW","content":"RecentSearches_content__27C38"};